import axiosAuth from "@/services/axiosAuth";
import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { PROJECT_API } from "../apiRoutes";

interface UseGetDependencyListProps {
  projectId: string;
  taskId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getDependencyList = async (taskId: string, projectId: string) =>
  await axiosAuth.get(`${PROJECT_API}/${projectId}/tasks/${taskId}/dependencies`);

const useGetDependencyList = ({
  taskId,
  projectId,
  queryParams,
}: UseGetDependencyListProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["dependencies", taskId],
    queryFn: () => getDependencyList(taskId, projectId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetDependencyList;
